import React, { useEffect, useState } from "react";
import { useNotas } from "../context/NotasContext";
import { useUsers } from "../context/UsersContext";
import Sidebar from "../components/Sidebar";
import HeaderPage from "../components/HeaderPage";
import NotasForm from "../components/Notas/NotasForm";
import NotasList from "../components/Notas/NotasList";
import NotasListStudentView from "../components/Notas/NotasListStudentView";
import { useAuth } from "../context/AuthContext";
import NotasAdminView from "../components/Notas/NotasAdminView";
import Notification from "../components/Notification";
import VisibilityToggleNotas from "../components/VisibilityToggleNotas"; // 🔥 NUEVO

const NotasPage = () => {
  const { user } = useAuth();
  const {
    notas,
    fetchNotasByDirector,
    fetchNotasByStudent,
    fetchNotasForAdmin,
    periodos,
    fetchPeriodos,
    createNotaData,
    deleteNotaData,
    updateNotaData,
    loading,
  } = useNotas();
  const {
    students,
    fetchStudentsByDirector,
    fetchStudents,
    asignaturas,
    salonGrado,
    fetchAsignaturas,
    fetchSalonForDirector,
  } = useUsers();

  const [editingNota, setEditingNota] = useState(null);
  const [notification, setNotification] = useState(null);
  const [adminView, setAdminView] = useState("tabla");
  
  const closeNotification = () => setNotification(null);

  useEffect(() => {
    if (user?.rol_id === 1) {
      fetchNotasForAdmin();
      fetchStudents();
      fetchAsignaturas();
      fetchPeriodos();
    } else if (user?.rol_id === 2) {
      fetchStudentsByDirector(user.id);
      fetchNotasByDirector(user.id);
      fetchPeriodos();
      fetchSalonForDirector();
      fetchAsignaturas();
    } else if (user?.rol_id === 3) {
      fetchNotasByStudent(user.id);
    }
  }, [user]);

  const handleEdit = (nota) => {
    setEditingNota(nota);
  };

  const clearEditing = () => {
    setEditingNota(null);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-6 overflow-y-auto">
        <HeaderPage title="Gestión de Notas" />
        {loading ? (
          <p className="text-center text-xl font-semibold">Cargando...</p>
        ) : user?.rol_id === 3 ? (
          <NotasListStudentView notas={notas} />
        ) : user?.rol_id === 1 ? (
          <>
            {/* 🔥 NUEVO: Botón de gestión de visibilidad para admin */}
            <div className="mb-6 flex justify-between items-center">
              <div className="flex gap-4">
                <button
                  onClick={() => setAdminView("tabla")}
                  className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
                    adminView === "tabla"
                      ? "bg-blue-600 text-white"
                      : "bg-gris "
                  }`}
                >
                  Vista de Tabla
                </button>
                <button
                  onClick={() => setAdminView("planilla")}
                  className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
                    adminView === "planilla"
                      ? "bg-blue-600 text-white"
                      : "bg-gris"
                  }`}
                >
                  Planilla de Edición
                </button>
              </div>
              
              {/* 🔥 Botón de visibilidad */}
              <VisibilityToggleNotas />
            </div>

            {adminView === "tabla" ? (
              <NotasAdminView 
                notas={notas} 
                deleteNotaData={deleteNotaData}
                updateNotaData={updateNotaData}
                showNotification={setNotification}
              />
            ) : (
              <NotasForm
                students={students}
                periodos={periodos}
                asignaturas={asignaturas}
                notas={notas}
                createNotaData={createNotaData}
                updateNotaData={updateNotaData}
                salonGrado={null}
                editingNota={null}
                clearEditing={() => {}}
                showNotification={setNotification}
              />
            )}
          </>
        ) : (
          <>
            <NotasForm
              students={students}
              periodos={periodos}
              asignaturas={asignaturas}
              notas={notas}
              createNotaData={createNotaData}
              updateNotaData={updateNotaData}
              salonGrado={salonGrado}
              editingNota={editingNota}
              clearEditing={clearEditing}
              showNotification={setNotification}
            />
            <NotasList
              notas={notas}
              deleteNotaData={deleteNotaData}
              onEdit={handleEdit}
              showNotification={setNotification}
            />
          </>
        )}
      </div>
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={closeNotification}
        />
      )}
    </div>
  );
};

export default NotasPage;